import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const DzzfFlagsMonthlyPage = lazy(() =>
	import("@/features/dzzf/dzzf-flags-monthly-page").then((m) => ({
		default: m.DzzfFlagsMonthlyPage,
	})),
);

// Miesiąc deep-linkowalny; zły param z zakładki nie może wywalić trasy (catch).
const searchSchema = z.object({
	month: z
		.string()
		.regex(/^\d{4}-(0[1-9]|1[0-2])$/)
		.optional()
		.catch(undefined),
});

export type AptekiProducentowHistoriaSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/kontrakty/apteki-producentow-historia")({
	// Strona uruchamiana z macierzy przypisań — ten sam element widoczności,
	// żeby nie mnożyć grantów (wzorzec: /kontrakty/{id} współdzieli
	// sidebar.kontrakty.definicje).
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.apteki-producentow",
			location.pathname,
		);
	},
	component: DzzfFlagsMonthlyPage,
	validateSearch: (search: Record<string, unknown>): AptekiProducentowHistoriaSearch =>
		searchSchema.parse(search),
});
